/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef } from 'react';

import TextInput from '../TextInput';

const defaultOptionsClasses = 'flex flex-wrap items-center -m-3';
const settingsFormOptionsClasses = 'flex flex-col';

export default function Radio({
  label,
  name,
  options,
  onChange,
  onBlur,
  error,
  touched,
  tabindex,
  isVisible,
  value,
  isSettingsForm,
  description,
  readOnly,
}) {
  const inputRef = useRef();

  // Focus on input if tabindex = 1
  useEffect(() => {
    if (tabindex === 1 && !readOnly) {
      inputRef.current.focus();
    }
  }, [tabindex, isVisible, readOnly]);

  // If the field is read-only, render a TextInput component with the value
  if (readOnly) {
    const currentOption = options.find((option) => option.value === value);
    return <TextInput label={label} value={currentOption?.label} readOnly />;
  }

  return (
    <div>
      {label && <h2 className="block text-sm font-medium mb-3">{label}</h2>}
      {description && (
        <p className="block text-sm text-gray-500 mb-3 px-1 dark:text-gray-400">
          {description}
        </p>
      )}
      <div
        className={
          isSettingsForm ? settingsFormOptionsClasses : defaultOptionsClasses
        }
      >
        {options.map((option, index) => (
          <div
            className={`${isSettingsForm ? 'm-1' : 'm-3'}`}
            key={option.value}
          >
            {/* Start */}
            <label className="flex items-center">
              <input
                ref={index === 0 ? inputRef : null}
                type="radio"
                name={name}
                value={option.value}
                className="form-radio"
                onChange={onChange}
                onBlur={onBlur}
                tabIndex={tabindex}
                checked={option.value === value}
                disabled={readOnly}
              />
              <span className="text-sm ml-2">{option.label}</span>
            </label>
            {/* End */}
          </div>
        ))}
      </div>
      {error && touched && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
}
